module.exports = __webpack_public_path__ + "static/media/moblieview_img3.c55bb9f5.png";